import { Icons } from 'app/constants/icons';

type Props = React.DetailedHTMLProps<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
>;

export function ExternalLink({children, ...props}: Props) {
  return (
    <a
      className="p-b-[2px] relative border-b-[1px] border-b-neutral-400 text-3xs font-normal leading-normal text-neutral-100 light:text-neutral-500"
      target="_blank"
      {...props}>
      {children}

      <Icons.arrowUpRight
        width="12"
        height="12"
        className="absolute -right-3.5 bottom-0 top-0 my-auto w-3 [&>*]:stroke-neutral-100 light:[&>*]:stroke-neutral-500"
      />
    </a>
  );
}
